import React, { useEffect, useState } from "react";
import { SidebarPostItems, SidebarPreItems } from "./SidebarItems";
import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "app/pages/module/auth";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "sr/redux/store";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { FilterRoutes } from "sr/helpers/functions/FilterRoutes";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { toast } from "react-toastify";
export const Sidebar = ({ isOpen, HandleOpen }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [preRecruit, setPreRecruit] = useState(true);
  const [postRecruit, setPostRecruit] = useState(true);
  const supervisorData = useSelector((state: any) => state?.supervisor?.data);
  const dispatch = useDispatch<AppDispatch>();
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [userId, serUserId] = useState();
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const appSettingsReloadSetting = useSelector(
    (s: RootState) => s.appSettings.reloadSetting,
  );

  const { userType } = useAuth();
  useEffect(() => {
    const getdetails = getUserDetails();
    serUserId(getdetails.user_id);
  }, []);
  useEffect(() => {
    (async () => {
      const userFullProfileRes = await getUserFullProfile();
      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, [appSettingsReloadSetting]);
  useEffect(() => {
    if (supervisorData) {
      setFilteredRoutes(FilterRoutes(supervisorData));
    }
  }, [supervisorData]);
  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        dispatch(fetchSupervisor({ id: userId }));
      }
    }
  }, [dispatch, userId, userType]);
  const HandleClick = () => {
    HandleOpen();
  };
  const roles = { SUPERVISOR: "supervisor", COMPANY: "company" };
  const SidebarPreItemsPerm = {
    [roles.COMPANY]: [
      "/job-post/add-basic-details",
      "/jobs-listing",
      "/candidates",
      "/supervisor/work-order",
      "/work-order",
      "/work-order-model",
      "/contractor",
      "/supervisor",
      "/manage-customer",
      "/projects",
      "/my-transactions",
    ],
    [roles.SUPERVISOR]: filteredRoutes
      ?.filter((item) => item?.permission?.includes("view"))
      ?.map((item) => item?.path),
  };

  let allowedLinks;

  if (userType === roles.SUPERVISOR) {
    allowedLinks = SidebarPreItemsPerm[roles.SUPERVISOR];
  } else if (userType === roles.COMPANY) {
    allowedLinks = SidebarPreItemsPerm[roles.COMPANY];
  } else {
    allowedLinks = [];
  }

  return (
    <div
      className={`fixed top-0 left-0 z-40 h-screen p-4 px-2 overflow-y-auto duration-200 bg-gray-900 text-white ${
        isOpen ? "w-48" : "w-14"
      }`}
    >
      <div
        onClick={HandleClick}
        className="flex items-center absolute top-10 right-0 cursor-pointer"
      >
        <div className="bg-[#fffefe] rounded-l-lg h-6 w-6 flex justify-center items-center">
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          )}
        </div>
      </div>
      <div className="py-4 mt-10">
        <ul className="space-y-4">
          {userType === "company" && (
            <li
              className={`flex items-center cursor-pointer rounded-lg hover:bg-[#424242] my-2`}
            >
              <span
                onClick={() => setPreRecruit(!preRecruit)}
                className="inline-flex items-center flex-shrink-0 p-1.5"
              ></span>
              <div
                onClick={() => setPreRecruit(!preRecruit)}
                className={`duration-300 overflow-hidden block ${
                  isOpen ? "block" : "hidden"
                }`}
              >
                <span className="origin-left truncate font-bold">
                  <FormattedMessage
                    id="RECRUITER.SIDEBAR.MENU.PREREQRUITEMENT"
                    defaultMessage="Pre Recruitement"
                  />
                </span>
              </div>
            </li>
          )}
          <div
            className={`${
              preRecruit ? (isOpen ? "block ml-2" : "block") : "hidden"
            }`}
          >
            {SidebarPreItems?.filter((link) =>
              allowedLinks?.includes(link?.link),
            ).map((data, index) => (
              <Link
                key={index}
                state={{ isFromSidebar: true }}
                onClick={() => {
                  if (data?.id && data.id == "add-job-post") {
                    if (
                      appSettingsData &&
                      appSettingsData?.isPlatformPaymentActive != undefined &&
                      appSettingsData?.isPlatformPaymentActive === true
                    ) {
                      if (
                        !userFullProfile?.id ||
                        !userFullProfile?.stripe_customer_detail ||
                        !userFullProfile?.stripe_customer_detail?.id ||
                        !userFullProfile?.stripe_customer_payment_methods ||
                        userFullProfile?.stripe_customer_payment_methods
                          ?.length == 0
                      ) {
                        // toast.error(
                        //   intl.formatMessage({
                        //     id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                        //     defaultMessage:
                        //       "Please set up your payment method first",
                        //   }),
                        // );
                        return;
                      }
                      if (
                        !userFullProfile?.stripe_customer_detail ||
                        !userFullProfile?.stripe_customer_detail
                          ?.default_payment_method ||
                        userFullProfile?.stripe_customer_detail
                          ?.default_payment_method == null ||
                        userFullProfile?.stripe_customer_detail
                          ?.default_payment_method == "null" ||
                        userFullProfile?.stripe_customer_detail
                          ?.default_payment_method == ""
                      ) {
                        toast.error(
                          intl.formatMessage({
                            id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
                            defaultMessage:
                              "Please set a default payment method first",
                          }),
                        );
                        return;
                      }
                    }
                    // alert("assd");
                    // navigate(data.link || "#", { replace: true });
                    window.location.href = data.link || "#";
                  }
                }}
                to={
                  // (!data?.id || data.id !== "add-job-post") && data.link
                  data.link ? data.link : "#"
                }
              >
                <li
                  className={`flex items-center rounded-lg hover:bg-[#424242] my-2`}
                >
                  <span className="inline-flex items-center flex-shrink-0 p-1.5">
                    {data.icon}
                  </span>
                  <div
                    className={`duration-300 overflow-hidden block ${
                      isOpen ? "block" : "hidden"
                    }`}
                  >
                    <span className="origin-left truncate">{data.text}</span>
                  </div>
                </li>
              </Link>
            ))}
          </div>
          {userType === "company" && (
            <li
              className={`flex items-center cursor-pointer rounded-lg hover:bg-[#424242] my-2`}
            >
              <span className="inline-flex items-center flex-shrink-0 p-1.5"></span>
              <div
                onClick={() => setPostRecruit(!postRecruit)}
                className={`duration-300 overflow-hidden block ${
                  isOpen ? "block" : "hidden"
                }`}
              >
                <span className="origin-left truncate font-bold">
                  <FormattedMessage
                    id="RECRUITER.SIDEBAR.MENU.POSTREQRUITEMENT"
                    defaultMessage="Post Recruitement"
                  />
                </span>
              </div>
            </li>
          )}

          <div
            className={`${
              preRecruit ? (isOpen ? "block ml-2" : "block") : "hidden"
            }`}
          >
            {SidebarPostItems?.filter((link) =>
              allowedLinks?.includes(link?.link),
            )
              ?.filter((link) => link?.section !== "payments")
              .map((data, index) => (
                <Link key={index} to={data.link ? data.link : "#"}>
                  <li
                    className={`flex items-center rounded-lg hover:bg-[#424242] my-2`}
                  >
                    <span className="inline-flex items-center flex-shrink-0 p-1.5">
                      {data.icon}
                    </span>
                    <div
                      className={`duration-300 overflow-hidden block ${
                        isOpen ? "block" : "hidden"
                      }`}
                    >
                      <span className="origin-left truncate">{data.text}</span>
                    </div>
                  </li>
                </Link>
              ))}

            {SidebarPostItems?.filter((link) =>
              allowedLinks?.includes(link?.link),
            )?.some((link) => link?.section === "payments") ? (
              <li
                className={`flex items-center rounded-lg hover:bg-[#424242] mt-4 mb-3 ${
                  isOpen ? "-ml-2" : ""
                }`}
              >
                <span className="inline-flex items-center flex-shrink-0 p-1.5"></span>
                <div
                  className={`duration-300 overflow-hidden block ${
                    isOpen ? "block" : "hidden"
                  }`}
                >
                  <span className="origin-left truncate font-bold">
                    <FormattedMessage
                      id="RECRUITER.SIDEBAR.MENU.PAYMENTS"
                      defaultMessage="Payments"
                    />
                  </span>
                </div>
              </li>
            ) : null}

            {SidebarPostItems?.filter((link) =>
              allowedLinks?.includes(link?.link),
            )
              ?.filter((link) => link?.section === "payments")
              .map((data, index) => (
                <Link
                  key={`payments-${index}`}
                  to={data.link ? data.link : "#"}
                >
                  <li
                    className={`flex items-center rounded-lg hover:bg-[#424242] my-2`}
                  >
                    <span className="inline-flex items-center flex-shrink-0 p-1.5">
                      {data.icon}
                    </span>
                    <div
                      className={`duration-300 overflow-hidden block ${
                        isOpen ? "block" : "hidden"
                      }`}
                    >
                      <span className="origin-left truncate">{data.text}</span>
                    </div>
                  </li>
                </Link>
              ))}
          </div>
        </ul>
      </div>
    </div>
  );
};
